
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { convertBoundingBoxToBox, transformBoxPoints } from '../geometry/conversion.mjs.js';

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}

export { measureViewportBox };
//# sourceMappingURL=measure.mjs.js.map
